import Eyebrow from "../shared/Eyebrow";
import TypedHeading from "../shared/TypedHeading";
import Reveal from "../shared/Reveal";
import AiLeadQualifier from "../AiLeadQualifier";
import useI18n from "../../i18n/useI18n";

const HomeAiSection = () => {
  const { t } = useI18n();

  return (
    <section id="ai" className="ai-section section">
      <div className="ai-section__wash" aria-hidden="true" />
      <div className="ai-section__inner">
        <div className="ai-section__copy">
          <Reveal><Eyebrow>{t("ai.eyebrow")}</Eyebrow></Reveal>
          <TypedHeading text={t("ai.title")} className="ai-section__title" />
          <Reveal as="p" className="ai-section__lede">{t("ai.lede")}</Reveal>
          <Reveal className="ai-section__facts">
            <div className="ai-section__fact">
              <div className="ai-section__fact-label">{t("ai.responseLabel")}</div>
              <div className="ai-section__fact-value">{t("ai.response")}</div>
            </div>
            <div className="ai-section__fact">
              <div className="ai-section__fact-label">{t("ai.commitmentLabel")}</div>
              <div className="ai-section__fact-value">{t("ai.commitment")}</div>
            </div>
          </Reveal>
        </div>

        <Reveal className="ai-section__panel">
          <AiLeadQualifier />
        </Reveal>
      </div>
    </section>
  );
};

export default HomeAiSection;
